module.exports = __webpack_public_path__ + "static/media/thumbnail.f7c191b7.jpg";